import React, { useEffect, useRef, useState } from 'react';
import Plot from 'react-plotly.js';

function LineChart({ issueTrend }) {
  const lineChartLayout = {
    font: {
      family: 'Raleway, sans-serif',
    },
    title: '',
    width: 480,
    paper_bgcolor: '#f5f5f5',
    plot_bgcolor: '#f5f5f5',
    height: 400,
    // showlegend: true,
    // xaxis: {
    //   title: {
    //     text: props?.data[0]?.xaxis_name,
    //     font: { size: 12 },
    //   },
    // },
    // yaxis: {
    //   title: {
    //     text: props?.data[0]?.yaxis_name,
    //     font: { size: 12 },
    //   },
    // },
  };
  const config = {
    responsive: true,
    displayModeBar: false,
  };

  return (
    <div
      style={{
        position: 'relative',
        width: '480px',
        height: '400px',
        // backgroundColor: "rgb(232, 232, 232)",
      }}
      //   onMouseEnter={() => setIsTrashVisible(true)}
      //   onMouseLeave={() => setIsTrashVisible(false)}
    >
      {/* {isEditingTitle ? (
        <input
          type="text"
          value={title}
          ref={titleInputRef}
          onChange={(e) => setTitle(e.target.value)}
          onBlur={() => handleEditTile()}
          style={{
            position: 'absolute',
            top: '32px',
            left: '50%',
            transform: 'translateX(-50%)',
            padding: '5px',
            fontSize: '16px',
            zIndex: 10,
          }}
        />
      ) : (
        <div
          role="button"
          tabIndex={0}
          style={{
            position: 'absolute',
            top: '30px',
            left: '50%',
            transform: 'translateX(-50%)',
            padding: '5px',
            fontSize: '18px',
            cursor: 'default',
            zIndex: 10,
            // fontWeight: '500',
          }}
          // onClick={() => setIsEditingTitle(true)}
          // onKeyDown={handleKeyDown}
        >
          {title !== '' ? title : `Analysis of ${props?.data[0]?.yaxis_name} by ${props?.data[0]?.xaxis_name}`}
        </div>
      )} */}
      <Plot
        data={[
          {
            x: issueTrend.map((item) => item.year),
            y: issueTrend.map((item) => item.issues),
            type: 'scatter',
            mode: 'lines+markers',
            marker: {
              color: 'rgb(142, 124, 195)',
            },
            fill: 'tozeroy',
            fillcolor: '#E8DAEF',
          },
        ]}
        config={config}
        layout={lineChartLayout}
      />
      {/* {isTrashVisible && (
        <>
          <button
            style={{
              position: 'absolute',
              top: '12%',
              right: '10px',
              transform: 'translateY(-50%)',
              cursor: 'pointer',
              border: 'none',
              background: 'none',
              padding: '0',
              outline: 'none',
              // color: 'grey',
            }}
            onClick={() => {
              setIsEditingTitle(true);
            }}
          >
            <FaEdit />
          </button>
          <Tooltip title="View Data">
            <button
              style={{
                position: 'absolute',
                top: '19%',
                right: '10px',
                transform: 'translateY(-50%)',
                cursor: 'pointer',
                border: 'none',
                background: 'none',
                padding: '0',
                outline: 'none',
                // color: 'grey',
              }}
              onClick={() => {
                setIsViewTable(true);
              }}
            >
              <FaInfoCircle />
            </button>
          </Tooltip>
          <button
            style={{
              position: 'absolute',
              top: '50%',
              right: '10px',
              transform: 'translateY(-50%)',
              cursor: 'pointer',
              border: 'none',
              background: 'none',
              padding: '0',
              outline: 'none',
            }}
            onClick={() => {
              handleDeleteTile(props?.rg_id);
            }}
          >
            <FaTrashAlt />
          </button>
        </>
      )}
      {isViewTable && (
        <ViewTable
          props={props?.data[0]}
          fileName={props?.fileName}
          setIsViewTable={setIsViewTable}
          title={props.title}
        />
      )} */}
    </div>
  );
}

export default LineChart;
